import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { ButtonGold } from "./Buttons";
import { NAV_LINKS, scrollToSection } from "../config";

export default function Nav({ onOpenForm }) {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 24);
        fn();
        window.addEventListener("scroll", fn, { passive: true });
        return () => window.removeEventListener("scroll", fn);
    }, []);

    const go = (id) => {
        setOpen(false);
        scrollToSection(id);
    };

    return (
        <header
            className={`fixed inset-x-0 top-0 z-[110] transition-colors duration-500 ${
                scrolled
                    ? "border-b border-gold-faint bg-[#0a0a0a]/85 backdrop-blur-xl"
                    : "border-b border-transparent bg-transparent"
            }`}
            data-testid="site-nav"
        >
            <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6 lg:px-10">
                <Logo onClick={() => go("#topo")} />
                <nav className="hidden items-center gap-9 lg:flex">
                    {NAV_LINKS.map((l) => (
                        <button
                            key={l.id}
                            onClick={() => go(l.id)}
                            data-testid={l.tid}
                            className="group relative font-mono text-[11px] uppercase tracking-[0.22em] text-[#888888] transition-colors duration-300 hover:text-white"
                        >
                            {l.label}
                            <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" />
                        </button>
                    ))}
                </nav>
                <div className="hidden lg:block">
                    <ButtonGold onClick={onOpenForm} tid="nav-cta-button" className="px-5 py-3">
                        Solicitar Esboço
                    </ButtonGold>
                </div>
                <button
                    className="p-2 text-[#e6e6e6] lg:hidden"
                    onClick={() => setOpen((o) => !o)}
                    data-testid="mobile-menu-button"
                    aria-label="Abrir menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden border-b border-gold-faint bg-[#0a0a0a]/95 backdrop-blur-xl lg:hidden"
                        data-testid="mobile-menu"
                    >
                        <div className="flex flex-col gap-1 px-6 py-6">
                            {NAV_LINKS.map((l) => (
                                <button
                                    key={l.id}
                                    onClick={() => go(l.id)}
                                    data-testid={`${l.tid}-mobile`}
                                    className="border-b border-white/5 py-4 text-left font-mono text-xs uppercase tracking-[0.22em] text-[#e6e6e6]"
                                >
                                    {l.label}
                                </button>
                            ))}
                            <ButtonGold
                                onClick={() => {
                                    setOpen(false);
                                    onOpenForm();
                                }}
                                tid="nav-cta-button-mobile"
                                className="mt-5 w-full"
                            >
                                Solicitar Esboço
                            </ButtonGold>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
}
